module.exports = __webpack_public_path__ + "static/media/download-pdf-icon.7910bf02.svg";